var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.5H5.5V4.25C5.5 5.49375 6.50625 6.5 7.75 6.5H10.5V14C10.5 14.275 10.275 14.5 10 14.5H2C1.725 14.5 1.5 14.275 1.5 14V2C1.5 1.725 1.725 1.5 2 1.5ZM7 2.12188L9.87813 5H7.75C7.33437 5 7 4.66563 7 4.25V2.12188ZM2 0C0.896875 0 0 0.896875 0 2V14C0 15.1031 0.896875 16 2 16H10C11.1031 16 12 15.1031 12 14V5.82812C12 5.29688 11.7906 4.7875 11.4156 4.4125L7.58437 0.584375C7.20937 0.209375 6.70312 0 6.17188 0H2ZM3.75 8C3.33437 8 3 8.33438 3 8.75C3 9.16562 3.33437 9.5 3.75 9.5H8.25C8.66562 9.5 9 9.16562 9 8.75C9 8.33438 8.66562 8 8.25 8H3.75ZM3.75 11C3.33437 11 3 11.3344 3 11.75C3 12.1656 3.33437 12.5 3.75 12.5H8.25C8.66562 12.5 9 12.1656 9 11.75C9 11.3344 8.66562 11 8.25 11H3.75Z",
    fill: "#B88333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/accounting.3109e63bad32201cbd0c2147fba4d889.svg";
export { ForwardRef as ReactComponent };